import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

const pageContainer: React.CSSProperties = {
  minHeight: '100vh',
  backgroundColor: '#261136',
  padding: 24,
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  fontFamily:
    'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
};

const shellCard: React.CSSProperties = {
  width: '100%',
  maxWidth: 900,
  background:
    'radial-gradient(circle at top, #3A1F52 0, #170824 45%, #12061f 100%)',
  borderRadius: 16,
  padding: 24,
  boxSizing: 'border-box',
  boxShadow: '0 18px 45px rgba(0,0,0,0.45)',
  color: '#F5F5FA',
};

const headerBlock: React.CSSProperties = {
  marginBottom: 16,
};

const titleStyle: React.CSSProperties = {
  fontSize: 22,
  fontWeight: 600,
};

const subtitleStyle: React.CSSProperties = {
  fontSize: 13,
  opacity: 0.8,
};

const itemRow: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 12,
  marginBottom: 10,
};

const itemLabel: React.CSSProperties = {
  fontSize: 14,
  maxWidth: 260,
};

const counterInput: React.CSSProperties = {
  width: 70,
  padding: '6px 8px',
  borderRadius: 6,
  border: '1px solid #61518A',
  backgroundColor: '#1F0F30',
  color: '#F5F5FA',
  textAlign: 'center' as const,
};

const noteBlock: React.CSSProperties = {
  marginTop: 12,
  fontSize: 12,
  opacity: 0.9,
  lineHeight: 1.5,
};

const footer: React.CSSProperties = {
  marginTop: 20,
  display: 'flex',
  justifyContent: 'flex-end',
};

const primaryButton: React.CSSProperties = {
  padding: '10px 16px',
  borderRadius: 6,
  border: 'none',
  backgroundColor: '#7B1FA2',
  color: '#FFF',
  fontSize: 14,
  fontWeight: 600,
  cursor: 'pointer',
};

const TenantNewPickupPage: React.FC = () => {
  const history = useHistory();
  const [itemCounts, setItemCounts] = useState<Record<string, number>>({});
  const type = 'PICKUP';

  const items = [
    'Boxes',
    'Sofas / Couches',
    'Beds / Mattresses / Dressers',
    'Dining Tables / Chairs',
    'Desks and Office Furniture',
    'Large Kitchen Appliances',
    'Large Sporting Goods',
    'Large Outdoor / Patio Furniture',
    'Large Tools / Equipment',
    'Large Mirrors',
    'Large Electronics',
  ];

  const handleItemChange = (itemKey: string, value: string) => {
    const num = Math.max(0, Number(value) || 0);
    setItemCounts(prev => ({ ...prev, [itemKey]: num }));
  };

  const capitalize = (str: string) =>
    str.charAt(0).toUpperCase() + str.slice(1);

  const handleNext = () => {
    const selectedItems = Object.entries(itemCounts)
      .filter(([, count]) => count > 0)
      .map(([key, count]) => {
        const label = key.replace('Count', '');
        return `${capitalize(label)} (${count})`;
      })
      .join(', ');

    if (!selectedItems) {
      window.alert('Please estimate at least one item to store.');
      return;
    }

    history.push('/tenant/neworder/schedule', {
      type,
      selected: selectedItems,
      needHelp: '',
      needPack: '',
    });
  };

  return (
    <div style={pageContainer}>
      <div style={shellCard}>
        <div style={headerBlock}>
          <h1 style={titleStyle}>Pick up items from me</h1>
          <div style={subtitleStyle}>
            Estimate what you plan to send into storage so we can assign the
            right vehicle and crew.
          </div>
        </div>

        <div>
          {items.map(item => {
            const key = `${item.toLowerCase()}Count`;
            const value = itemCounts[key] ?? 0;
            return (
              <div key={item} style={itemRow}>
                <div style={itemLabel}>{item}</div>
                <input
                  type="number"
                  min={0}
                  value={value}
                  onChange={e => handleItemChange(key, e.target.value)}
                  style={counterInput}
                />
              </div>
            );
          })}
        </div>

        <div style={noteBlock}>
          Prohibited items: food, drugs, guns, chemicals, pianos, building
          materials, car parts, fragile or expensive art.
          <br />
          Please make sure all loose items are packed up. Dressers, fridges,
          etc. must be empty.
        </div>

        <div style={footer}>
          <button type="button" style={primaryButton} onClick={handleNext}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default TenantNewPickupPage;
